/* eslint-disable no-console */
// Sourcing Change Data Reducer

import defaultData from '../Components/DefaultData';


//Default to test data
const dataReducerDefaultState = {
    payload       : [],
    defaultData   : defaultData,
    isNewSearched : false,
    pageSize      : 5,
    pageOffset    : 1,
    rowCount      : undefined,
    dataCached    : false
};

export default (state = dataReducerDefaultState, action) => {
    switch(action.type) {
        case 'LOAD_DATA':
            return {
                ...state,
                payload : action.payload.length === 0 ? dataReducerDefaultState.payload : action.payload
            };
        case 'LOAD_CACHE_SEARCH_DATA':
            return {
                ...state,
                payload : action.payload ? action.payload : state.defaultData
            };
        case 'SET_DATA_CACHED':
            return {
                ...state,
                dataCached : action.dataCached
            };
        case 'SET_PAGE_SIZE':
            return {
                ...state,
                pageSize : action.pageSize
            };
        case 'SET_PAGE_INDEX':
            return {
                ...state,
                pageIndex : action.pageIndex
            };
        case 'SET_PAGE_OFFSET':
            return {
                ...state,
                pageOffset : action.pageOffset
            };
        case 'SET_IS_SEARCHED':
            return {
                ...state,
                isSearched : action.isSearched
            };
        case 'SET_NEW_SEARCH':
            return {
                ...state,
                isNewSearched : action.isNewSearched
            };
        case 'SET_ROW_COUNT':
            return {
                ...state,
                rowCount : action.rowCount
            };
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/Reducers/data.js